export const getUniqueSizes = (childProducts) => {
  const uniqueSizes = [];
  const seenSizesUids = new Set();

  childProducts.forEach((cp) => {
    if (cp.size?.uid && !seenSizesUids.has(cp.size.uid)) {
      uniqueSizes.push(cp.size);
      seenSizesUids.add(cp.size.uid);
    }
  });

  return uniqueSizes;
};
